import {
    useBusinessHoursStore,
    useInboxesStore,
    useNumberStore,
    useOrganizationStore,
    useSubscriptionsStore,
    useUserStore,
} from 'store/modules';

export default {
    getCountriesOptions(countriesCodes = []) {
        const countries = [];

        if (countriesCodes.includes('US'))
            countries.push({ id: 'US', name: 'United States', value: 'US', icon: 'united-states' });
        if (countriesCodes.includes('CA'))
            countries.push({ id: 'CA', name: 'Canada', value: 'CA', icon: 'canada' });
        if (countriesCodes.includes('UK'))
            countries.push({
                id: 'UK',
                name: 'United Kingdom',
                value: 'UK',
                icon: 'united-kingdom',
            });
        if (countriesCodes.includes('AU'))
            countries.push({ id: 'AU', name: 'United States', value: 'US', icon: 'united-states' });
        if (countriesCodes.includes('world'))
            countries.push({ id: 'world', name: 'Other', value: 'world', icon: 'world' });

        return countries;
    },

    async getAllTeams() {
        try {
            await useInboxesStore().getAllTeams();
        } catch (e) {
            console.log(e);
        }
    },

    async getTeams() {
        try {
            await useInboxesStore().getTeams({ origin: true });
        } catch (e) {
            console.log(e);
        }
    },

    async loadMultiOrganizationsList() {
        try {
            await useOrganizationStore().loadMultiOrganizationsList();
        } catch (e) {
            console.log(e);
        }
    },

    async getSubscription() {
        try {
            await useSubscriptionsStore().getSubscription();
        } catch (e) {
            console.log(e);
        }
    },

    async getUserMe() {
        try {
            await useUserStore().getUserMe();
        } catch (e) {
            console.log(e);
        }
    },

    async getBusinessHours() {
        try {
            await useBusinessHoursStore().getBusinessHours();
        } catch (e) {
            console.log(e);
        }
    },

    async getOrganization() {
        try {
            await useOrganizationStore().getOrganization();
        } catch (e) {
            console.log(e);
        }
    },

    async getOrganizationSettings() {
        try {
            await useOrganizationStore().getOrganizationSettings();
        } catch (e) {
            console.log(e);
        }
    },

    async getUsersConfig() {
        try {
            await useUserStore().getUsersConfig();
        } catch (e) {
            console.log(e);
        }
    },

    async getUsersPermissions() {
        try {
            await useUserStore().getUsersPermissions();
        } catch (e) {
            console.log(e);
        }
    },

    async getOrganizationNumber() {
        try {
            await useNumberStore().getOrganizationNumber();
        } catch (e) {
            console.log(e);
        }
    },

    async getNumbersIntegration() {
        try {
            await useNumberStore().getNumbersIntegration();
        } catch (e) {
            console.log(e);
        }
    },

    async getUserOwner() {
        try {
            await useUserStore().getUserOwner();
        } catch (e) {
            console.log(e);
        }
    },
};
